import { AviaLegTypes, GroundLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { AviaTransportInfo } from './AviaTransportInfo';

type TransportInformationProps = {
  leg: AviaLegTypes | GroundLegTypes;
};

export const TransportInformation = ({ leg }: TransportInformationProps) => {
  switch (leg.legType) {
    case RouteLegTypeEnum.TmdxJetAviaLeg:
    case RouteLegTypeEnum.SupplementalLiftAviaLeg:
    case RouteLegTypeEnum.TxCenterProviderAviaLeg:
      return <AviaTransportInfo leg={leg} />;
    case RouteLegTypeEnum.TmdxAffiliateGroundLeg:
    case RouteLegTypeEnum.TxCenterProviderGroundLeg:
      return leg.plateNumber ? (
        <div className="flex items-center gap-1">
          <span className="text-m-sb text-base-5">{leg.plateNumber}</span>
        </div>
      ) : null;
    default:
      return null;
  }
};
